module.exports = __webpack_public_path__ + "static/daily-activity-2-f9d7ddfc89dc4741b975caf6b3d98452.png";